module.exports = __webpack_public_path__ + "media/images/crown-befc7c43c6d1dcd58fdea793a2b8b8c7.svg";